<h2>Dispersiones Completadas</h2>
  <dx-data-grid [dataSource]="dispersions" keyExpr="id" [showBorders]="true"
      [allowColumnReordering]="true">
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <!-- <dxo-search-panel [visible]="true"></dxo-search-panel> -->
      <!-- <dxo-group-panel [visible]="true"></dxo-group-panel> -->
      <!-- <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping> -->
      <!-- <dxo-filter-row [visible]="true" applyFilter="showHeaderFilter"></dxo-filter-row> -->
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center">
      </dxi-column>
      <!-- <dxi-column dataField="dateScheduled" caption="Fecha programada" cellTemplate="dateTemplate"
          alignment="center">
      </dxi-column> -->
      <!-- <dxi-column dataField="dateExecuted" caption="Fecha ejecutada" cellTemplate="dateTemplate"
          alignment="center">
      </dxi-column>-->
      <dxi-column dataField="companyName" caption="Compañía" alignment="center">
      </dxi-column>
      <!-- <dxi-column dataField="programName" caption="Programa"></dxi-column> -->
      <!-- <dxi-column dataField="dispersionTypeName" caption="Tipo"></dxi-column> -->
      <dxi-column dataField="dispersionAmount" caption="Cantidad" dataType="number" format="currency"
          alignment="center">
          <dxo-format type="currency" [precision]="2"></dxo-format>
      </dxi-column>
      <dxi-column dataField="fees" caption="Comisión" dataType="number" format="currency" alignment="center">
          <dxo-format type="currency" [precision]="2"></dxo-format>
      </dxi-column>
      <dxi-column dataField="tax" caption="IVA" dataType="number" format="currency" alignment="center">
          <dxo-format type="currency" [precision]="2"></dxo-format>
      </dxi-column>
      <dxi-column dataField="granTotal" caption="Total" dataType="number" format="currency" alignment="center">
          <dxo-format type="currency" [precision]="2"></dxo-format>
      </dxi-column>
      <dxi-column dataField="id" caption="" cellTemplate="btn" alignment="right"></dxi-column>
      <!-- <dxi-column dataField="status" caption="Status" cellTemplate="status" alignment="center"></dxi-column> -->
      <dxo-summary>
          <dxi-total-item column="companyName" summaryType="count">
          </dxi-total-item>
          <dxi-total-item column="dispersionAmount" summaryType="sum" valueFormat="currency">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
          </dxi-total-item>
          <dxi-total-item column="fees" summaryType="sum" valueFormat="currency">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
          </dxi-total-item>
          <dxi-total-item column="tax" summaryType="sum" valueFormat="currency">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
          </dxi-total-item>
          <dxi-total-item column="granTotal" summaryType="sum" valueFormat="currency">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
          </dxi-total-item>
      </dxo-summary>
      <div *dxTemplate="let d of 'dateTemplate'">
          <div *ngIf="d.value"> {{d.value|numberToDate}}</div>
      </div>
      <div *dxTemplate="let btn of 'btn'">
          <dx-button text="" icon="find" type="default" (onClick)="viewDetail(btn.value)"></dx-button>
      </div>
  </dx-data-grid>